import { createContext, useContext, useState } from 'react';

const ReportHostTasksContext = createContext();

const initialState = {};

const startedAt = new Date();
startedAt.setDate(1);

const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  startedAt,
  endedAt: new Date(),
  brand: null,
};

const ReportHostTasksProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return <ReportHostTasksContext.Provider value={{ updateState, ...state, updateFilterState, filterState }}>{children}</ReportHostTasksContext.Provider>;
};

export const useReportHostTasksState = () => {
  return useContext(ReportHostTasksContext);
};

export default ReportHostTasksProvider;
